// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Drive = function Drive(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.243 10.987h1.11v1.11h-1.11zM11.243 6.185h1.11v1.11h-1.11z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.523 4.848a1.033 1.033 0 00-.112-.429H14.4l-2.136-2.768H3.745L1.58 4.419h.015a.9.9 0 00-.117.43v3.785a.914.914 0 00.155.508.914.914 0 00-.154.506v3.785a.915.915 0 00.914.914h11.215a.915.915 0 00.914-.914V9.649a1.168 1.168 0 00-.149-.517.907.907 0 00.149-.5zm-1.092 8.407H2.571V9.827h10.86zm0-4.8H2.571V5.026h10.86z"
    }))
  );
};

export default Drive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Drive.js
// module id = 1000
// module chunks = 0